import { assertNever } from "@impero-com/common/utils/obj";

import { useTestingProgramsQuery } from "../../list/queries/useTestingProgramsQuery";

function normalizeName(name: string): string {
    return name.trim().toLowerCase();
}

type NameValidator = (name: string) => boolean;

export function useTestingProgramNameValidator(
    currentId?: number
): NameValidator {
    const { data, status } = useTestingProgramsQuery();

    return (name: string): boolean => {
        switch (status) {
            case "success":
                const normalizedName = normalizeName(name);
                return !data.content.some((program) => {
                    // We don't compare against self when editing
                    if (currentId && program.resource.id === currentId) {
                        return false;
                    }
                    return (
                        normalizeName(program.resource.name) === normalizedName
                    );
                });
            case "error":
                return true;
            default:
                assertNever(status);
        }
    };
}
